module.exports = __webpack_public_path__ + "static/media/Stellar.5fc50d33.jpg";